import { useState, useEffect } from "react";

import axios from "axios";



import { Button, Card } from "antd";

const EU_COUNTRIES = [

  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "PK",

  "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"

];

const CookieBanner = () => {

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const checkUserLocation = async () => {
      try {
        const { data } = await axios.get("https://api.country.is/");
        if (EU_COUNTRIES.includes(data.country) && !localStorage.getItem("cookiesAccepted")) {
          setShowBanner(true);
        }
      } catch (error) {
        console.error("Error fetching user location:", error);
      }
    };

    checkUserLocation();
  }, []);

  const acceptCookies = () => {

    localStorage.setItem("cookiesAccepted", "true");

    setShowBanner(false);

  };

  if (!showBanner) return null;

  return (
    <div

      initial={{ opacity: 0, y: 20 }}

      animate={{ opacity: 1, y: 0 }}

      exit={{ opacity: 0, y: 20 }}
      style={{position: 'fixed',
        bottom: 0,
        width: '100%',
        zIndex: 999}}
      className="fixed bottom-4 left-4 right-4 bg-white shadow-lg p-4 rounded-lg z-50"
    >
      <Card>
        <div className="p-4 flex flex-col sm:flex-row items-center" style={{justifyContent:'space-between'}}>
          <p className="text-sm text-gray-700">

            This website uses cookies to enhance your experience. By continuing, you accept our <a href="/privacy-policy">cookie policy</a>.
          </p>
          <Button onClick={acceptCookies} className="mt-2 sm:mt-0">

            Accept
          </Button>
        </div>
      </Card>
    </div>

  );

};

export default CookieBanner;

